//A reusable password recovery form component (used in PasswordRecoveryPage.js).
import React, { useState } from 'react';
import '../App.css'; // Import external CSS file for styling

function PasswordRecovery() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/password-recovery`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }), // Send email in the request body
            });
            if (response.ok) {
                setMessage('Письмо для восстановления пароля отправлено. Посмотрите в почтовый ящик.');
            } else {
                // Parse error response to display a meaningful message
                const errorData = await response.json();
                setMessage(errorData.message || 'Ошибка при отправке email.');
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('Возникла ошибка. Пожалуйста, попробуйте позже.');
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            
            <input
                type="email"
                name="email"
                placeholder="Введите ваш email"
                required
                value={email} // Bind input value to state
                onChange={(e) => setEmail(e.target.value)} // Update state on change
            />
            <button type="submit">Отправить</button>
            {message && <p>{message}</p>} {/* Display the success or error message */}
        </form>
    );
}

export default PasswordRecovery;
